import { createTheme } from "@mui/material"

import { theme } from "../../../../../theme/theme"

// Scoped theme for the Tenant usage tab: Source Serif 4 as the base font (design mockup),
// while keeping everything else from the app theme (tailwind palette, component defaults).
// "Hero" numbers/titles override this locally with Playfair Display.
export const tenantUsageTheme = createTheme(theme, {
    typography: {
        fontFamily: '"Source Serif 4", Georgia, "Times New Roman", serif',
    },
})
